export default [
  {
    path: '/circular',
    name: 'circular',
    component: () => import('@/views/menu/circular/circular.vue'),
    meta: {
      pageTitle: 'بخشنامه ها',
      action: 'show',
      resource: 'CircularManager',
    },
  },
  {
    path: '/circular/details',
    name: 'addcircular',
    component: () => import('@/views/menu/circular/circulardetails.vue'),
    meta: {
      pageTitle: 'ایجاد بخشنامه',
      action: 'show',
      resource: 'CircularManager',
    },
  },
  {
    path: '/circular/details/:id',
    name: 'updatecircular',
    component: () => import('@/views/menu/circular/circulardetails.vue'),
    meta: {
      pageTitle: 'ویرایش بخشنامه',
      action: 'show',
      resource: 'CircularManager',
    },
  },
  {
    path: '/circularprocesstype',
    name: 'circularprocesstype',
    component: () => import('@/views/menu/circular/circularprocesstype.vue'),
    meta: {
      pageTitle: 'نوع های فرآیند',
      action: 'show',
      resource: 'CircularProcessTypeManager',
    },
  },
  {
    path: '/circulardocumenttype',
    name: 'circulardocumenttype',
    component: () => import('@/views/menu/circular/circulardocumenttype.vue'),
    meta: {
      pageTitle: 'نوع های سند',
      action: 'show',
      resource: 'CircularDocumentTypeManager',
    },
  },
]
